// extracted by mini-css-extract-plugin
module.exports = {"fumin":"src-pages-fuminAuth-__index__fumin--2PoAN"};